global.dataLayer = global.dataLayer || []
global.sc_count = global.sc_count || (name => console.log('%cGA Event%c %s', 'color: purple;', '', name))

if (global.innerWidth <= 720) {
  const meta = document.createElement('meta')
  meta.name = 'sc_page'
  meta.content = 'sma'
  document.getElementsByTagName('head')[0].appendChild(meta)
}

/**
 * GAディメンジョンを設定します
 *
 * @param {number} storeId 店舗ID
 * @param {number} [reserveId] 予約ID
 */
export function setDimension(storeId, reserveId) {
  const dimension = { dLsid: storeId, dLcd27: reserveId }
  console.log('%cGA setDimension%c %o', 'color: purple;', '', dimension)
  global.dataLayer.push(dimension)
}

/**
 * GAイベントを発行します
 * @see https://gnavi-work.gnavi.co.jp/wiki/pages/viewpage.action?pageId=10004721
 *
 * @param {string} name イベント名
 */
export function event(name) {
  global.sc_count(name)
}
